<template>
  <div class="word-display" :class="getArtClass" scroll-y :scroll-top="config.scrollTop" scroll-with-animation>
    <div @click="wordsClickHandler" class="book-words" :class="getRowClass" :style="getWidth">
      <div class="word-row" @click="rowClickHandler(row,index)" :class="[config.currentLineNum == index ? 'actived': '' , partNum>0 && partNum!= row.id ? 'hid': '' , row.signId > -1 ? 'sign_' + row.signId : '']" :id="'line'+index" v-for="(row,index) in config.displayLines" :key="index">
        <WordRow :row="row" :styleType="config.wordPageStyle" />
        <div class="empty-row" v-if="row.emptyRow" :style="{height: row.rowHeight+'px'}" v-for="n in row.emptyRow"></div>
      </div>
    </div>
  </div>
</template>
<script>
import WordRow from 'business/WordRow';
import { mapGetters } from "vuex";
export default {
  components: {
    WordRow
  },
  computed: {
    ...mapGetters(["getKnowledgeSettings"]),
    getArtClass() {
      let config = this.config;
      let classes = [];
      if (this.partNum < 0) {
        if (config.displayLines.length < config.maxRow) {
          classes.push('flex-center');
          this.$store.dispatch('setIsFlexCenter', true)
        } else {
          this.$store.dispatch('setIsFlexCenter', false)
        }
      } else {
        let lines = config.displayLines.filter(item => {
          return item.partNum == this.partNum
        });
        if (lines.length < config.maxRow) {
          classes.push('flex-center');
          this.$store.dispatch('setIsFlexCenter', true)
        } else {
          this.$store.dispatch('setIsFlexCenter', false)
        }
      }
      return classes;
    },
    getRowClass() {
      let config = this.config;
      let classes = ['book-words-' + config.wordPageStyle];
      if (config.style && config.style.textAlign) {
        classes.push('textAlign-' + config.style.textAlign);
      }
      if (config.isWrite) {
        classes.push('book-words-write')
      }
      if (config.isHasTime && config.type != 2 && config.canClickRow) {
        classes.push('row-click')
      }
      return classes
    },
    getWidth() {
      const scale = this.getKnowledgeSettings.size;
      const mul = 100 / (scale > 1 ? scale : 1);
      return this.config.isScale ? `width: ${mul}%;` : ''
    }
  },
  props: {
    partNum: {
      type: Number,
      default: -1
    },
    config: {
      type: Object,
      default () {
        return {
          displayLines: [],
          wordPageStyle: 0,
          
        }
      }
    }
  },
  methods: {
    wordsClickHandler() {
      this.$emit('onWordsClick')
    },
    rowClickHandler(row, index) {
      if (this.config.canClickRow) {
        this.$emit('onRowClick', {
          row,
          index
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.word-display {
  height: 100%;
  &.flex-center {
    .book-words {
      padding-bottom: 0;
      height: 100%;
    }
  }
}
</style>